import { useUser } from "./useUser";
import axios from "axios";
import { routes } from "../gen/General";
import { useEffect, useRef, useState } from "react";
import { Executive } from "../interface/executive.interface";

export const useExecutives = () => {
    const isMounted = useRef(false);
    const [policyExecutives, setPolicyExecutives] = useState<Executive[]>([]);
    const { asociados, asociadosVam } = useUser();

    useEffect(() => {
        isMounted.current = true;
        getAllExecutives();

        return () => {
            isMounted.current = false;
        };
    }, []);

    const getAllExecutives = () => {
        const clientIds = asociados.map(contractor => contractor.cdCliente);
        const identityCards = asociadosVam.map(insued => insued.cedula);
        axios
            .post<{ values: Executive[] }>(routes.api + "/ejecutivos-all", { clientIds, identityCards })
            .then(({ data }) => {
                const executives = data.values;
                if (isMounted.current) setPolicyExecutives(executives);
            });
    };

    return { policyExecutives };
};
